import React, { Component } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import Select from "react-select";
import { Button } from "@appcues/component-library";
import { selectAccountChecklist } from "reducers/account/checklists";
import CharacterCount from "components/Common/Forms/CharacterCount";
import ColorPicker from "components/Common/ColorPicker";
import FieldGroup from "components/Common/Forms/FieldGroup";
import Input from "components/Common/Forms/Input";
import BeaconOffset from "components/ChecklistsEdit/BeaconOffset";

export const defaultBeaconTextColor = "#FFFFFF";
export const dropdownOptions = [
  { label: "Bottom Left", value: "Bottom Left" },
  { label: "Bottom Right", value: "Bottom Right" }
];

export class BeaconFields extends Component {
  state = {
    isBeaconOffsetCollapsed: true
  };

  adjustToggle = () => {
    this.setState(({ isBeaconOffsetCollapsed }) => ({
      isBeaconOffsetCollapsed: !isBeaconOffsetCollapsed
    }));
  };

  updateChecklistBeaconTextColor = input =>
    this.props.updateChecklistStyles("beaconTextColor", input);

  updateChecklistBeaconTextColorSlider = hex => {
    this.props.updateChecklistStylesSlider("beaconTextColor", hex);
  };

  updateChecklistBeaconText = input =>
    this.props.updateLimitedChecklistTextToken("beaconText", 20, input);

  updateChecklistBeaconPosition = input =>
    this.props.updateChecklistStylesDropdown("position", input);

  updateBeaconHorizontalOffset = value => {
    const data = { target: { value: Number(value) || 0 } };

    this.props.updateChecklistStyles("beaconHorizontalOffset", data);
  };

  updateBeaconVerticalOffset = value => {
    const data = { target: { value: Number(value) || 0 } };

    this.props.updateChecklistStyles("beaconVerticalOffset", data);
  };

  render() {
    const { isBeaconOffsetCollapsed } = this.state;
    const {
      beaconText,
      beaconTextColor,
      beaconTextError,
      beaconVerticalOffset,
      beaconHorizontalOffset,
      position,
      resetBeaconTextError
    } = this.props;

    return (
      <div>
        <h2>Beacon</h2>
        <FieldGroup title="Position" className="configuration-item">
          <Select
            className="select-segment"
            clearable={false}
            value={position}
            options={dropdownOptions}
            autosize={false}
            onChange={this.updateChecklistBeaconPosition}
          />
          <AdjustButton onClick={this.adjustToggle}>Adjust</AdjustButton>
        </FieldGroup>
        <BeaconOffset
          collapsed={isBeaconOffsetCollapsed}
          beaconVertical={beaconVerticalOffset}
          beaconHorizontal={beaconHorizontalOffset}
          updateBeaconHorizontalOffset={this.updateBeaconHorizontalOffset}
          updateBeaconVerticalOffset={this.updateBeaconVerticalOffset}
        />
        <FieldGroup title="Beacon Text" className="configuration-item">
          <Input
            type="text"
            className="checklist-text-short"
            value={beaconText}
            placeholder="Get Started"
            invalid={beaconTextError}
            onBlur={resetBeaconTextError}
            onChange={this.updateChecklistBeaconText}
          />
          <CharacterCount input={beaconText} maxLength={20} />
        </FieldGroup>
        <FieldGroup className="configuration-item" title="Beacon Text Color">
          <ColorPicker
            color={beaconTextColor}
            defaultColor={defaultBeaconTextColor}
            onChangeSlider={this.updateChecklistBeaconTextColorSlider}
            onChangeInput={this.updateChecklistBeaconTextColor}
          />
        </FieldGroup>
      </div>
    );
  }
}

const mapStateToProps = (state, { checklistId }) => {
  const checklist = selectAccountChecklist(state, checklistId);
  const beaconVerticalOffset =
    checklist.styles && checklist.styles.beaconVerticalOffset;
  const beaconHorizontalOffset =
    checklist.styles && checklist.styles.beaconHorizontalOffset;
  const beaconText = checklist.textTokens && checklist.textTokens.beaconText;
  const beaconTextColor = checklist.styles && checklist.styles.beaconTextColor;
  const position = checklist.styles && checklist.styles.position;

  return {
    beaconHorizontalOffset,
    beaconText,
    beaconTextColor,
    beaconVerticalOffset,
    position
  };
};

const AdjustButton = styled(Button)`
  margin-left: 10px;
`;

export default connect(mapStateToProps)(BeaconFields);
